// Small dropdown: [data-toggle] button opens [data-panel]; closes on outside click, Escape or focus leaving.
// Arrow keys move between links inside the panel.
if (!customElements.get('lz-dropdown')) {
  class LzDropdown extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-toggle]');
      this.panel = this.querySelector('[data-panel]');
      if (!this.toggle || !this.panel) return;
      this.onToggle = () => (this.panel.hidden ? this.open() : this.close());
      this.onOutside = (e) => { if (!this.contains(e.target)) this.close(); };
      this.onKey = (e) => this.key(e);
      // Focus leaving closes the panel for keyboard users. While a pointer is pressed inside, another component
      // may pull the focus away (the open cart drawer traps focus); closing then would swallow the click.
      this.onPointerDown = () => { this.pointerInside = true; };
      this.onPointerEnd = () => { setTimeout(() => { this.pointerInside = false; }, 0); };
      this.onFocusOut = (e) => { if (!this.pointerInside && e.relatedTarget && !this.contains(e.relatedTarget)) this.close(); };
      this.toggle.addEventListener('click', this.onToggle);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('pointerdown', this.onPointerDown);
      document.addEventListener('pointerup', this.onPointerEnd);
      document.addEventListener('pointercancel', this.onPointerEnd);
    }

    disconnectedCallback() {
      this.close();
      this.toggle?.removeEventListener('click', this.onToggle);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('pointerdown', this.onPointerDown);
      document.removeEventListener('pointerup', this.onPointerEnd);
      document.removeEventListener('pointercancel', this.onPointerEnd);
    }

    get links() {
      return [...this.panel.querySelectorAll('a')];
    }

    open() {
      this.panel.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('pointerdown', this.onOutside);
      document.addEventListener('keydown', this.onKey);
    }

    close() {
      if (!this.panel || this.panel.hidden) return;
      this.panel.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', this.onOutside);
      document.removeEventListener('keydown', this.onKey);
    }

    key(e) {
      if (e.key === 'Escape') { this.close(); this.toggle.focus(); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      const links = this.links;
      const i = links.indexOf(document.activeElement);
      const next = e.key === 'ArrowDown' ? (i + 1) % links.length : (i - 1 + links.length) % links.length;
      links[i === -1 ? 0 : next]?.focus();
    }
  }
  customElements.define('lz-dropdown', LzDropdown);
}
